<app-pias-layout>
  <div pias-layout-content>
    <br />
    <h4 class="page-header">Campaign Details</h4>
    <div class="stats-grid">
      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-icon-wrap blue">
            <mat-icon>group</mat-icon>
          </div>
          <p class="stat-label">Total Recipients</p>
          <h2 class="stat-value">{{campaign.totalRecipients}}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-icon-wrap orange">
            <mat-icon>schedule</mat-icon>
          </div>
          <p class="stat-label">Scheduled</p>
          <h2 class="stat-value">{{campaign.scheduledCount}}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-icon-wrap green">
            <mat-icon>check_circle</mat-icon>
          </div>
          <p class="stat-label">Completed</p>
          <h2 class="stat-value">{{campaign.successCount}}</h2>
        </mat-card-content>
      </mat-card>

      <mat-card class="stat-card">
        <mat-card-content>
          <div class="stat-icon-wrap grey">
            <mat-icon>event</mat-icon>
          </div>
          <p class="stat-label">Draft</p>
          <h2 class="stat-value">{{campaign.draftCount}}</h2>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="campaign-detail-wrapper">
      <!-- Campaign Header -->
      <div class="campaign-header">
        <div class="header-left">
          <h2 class="campaign-name">
            {{ campaign.name }}
            <span class="status-badge" [ngClass]="'status-' + campaign.status.toLowerCase()">
              {{ campaign.status }}
            </span>
          </h2>
        </div>
        <!-- <div class="header-right">
          <div class="header-info">
            <mat-icon>calendar_today</mat-icon>
            <span
              >Created: <strong>{{ campaign.createdDate }}</strong></span
            >
          </div>
          <div class="header-info">
            <mat-icon>person</mat-icon>
            <span
              >Created By: <strong>{{ campaign.createdBy }}</strong></span
            >
          </div>
        </div> -->
      </div>

      <!-- Tabs -->
      <mat-card appearance="raised">
        <mat-card-content>
          <mat-tab-group class="campaign-tabs">
            <!-- Details Tab -->
            <mat-tab label="Details">
              <div class="tab-content">
                <div class="details-container">
                  <!-- Details Panel -->
                  <div class="details-panel">
                    <h3 class="section-title">Details</h3>

                    <div class="details-grid">
                      <div class="detail-item">
                        <span class="detail-label">Campaign Name:</span>
                        <span class="detail-value">{{ campaign.name }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Channel:</span>
                        <div class="channel-badge">
                          <mat-icon>{{ getChannelIcon(campaign.channel) }}</mat-icon>
                          <span>{{ campaign.channel }}</span>
                        </div>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Status:</span>
                        <span class="detail-value">{{ campaign.status }}</span>
                        <span
                          class="status-date"
                          *ngIf="campaign.status === 'completed' "
                        >
                          {{ campaign.updatedAt | date:'dd/MM/yyyy, h:mm a':'+0800' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Total Recipients:</span>
                        <span class="detail-value highlight">{{ campaign.totalRecipients }}</span>
                      </div>
                    </div>

                    <!-- Template Section -->
                    <div class="template-section" *ngIf="campaign.channel === 'email' ">
                      <div class="template-header">
                        <h4 class="template-title">Subject: {{ campaign.subject }}</h4>
                      </div>
                      <div class="template-content" [innerHTML]="campaign.messageTemplate"></div>
                    </div>
                  </div>

                  <!-- Actions Sidebar -->
                 <div
  class="actions-sidebar"
  *ngIf="campaign.status.toLowerCase() === 'draft' || campaign.status.toLowerCase() === 'scheduled'"
>
  <h3 class="section-title">Actions</h3>

  <!-- Send Now -->
  <div class="action-block">
    <p class="action-description">You can send the campaign immediately.</p>

    <button
      color="primary"
      class="action-btn full-width"
      (click)="_sendNow()"
    >
      <mat-icon>send</mat-icon>
      Send Campaign Now
    </button>
  </div>

  <div class="action-divider"></div>

  <!-- Schedule -->
  <div class="action-block" [formGroup]="scheduleForm">
    <p class="action-description">
      Or, you can schedule it to be sent later:
    </p>

    <div class="schedule-inputs">
      <mat-label>Schedule Date</mat-label>
      <mat-form-field appearance="outline" class="schedule-field">
        <input
          matInput
          [matDatepicker]="datepicker"
          formControlName="scheduleDate"
        />
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
      </mat-form-field>

       <mat-label>Schedule Time</mat-label>
      <mat-form-field appearance="outline" class="schedule-field">
        <input
          matInput
          [matTimepicker]="timepicker"
          formControlName="scheduleTime"
        />
        <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle>
        <mat-timepicker #timepicker></mat-timepicker>
      </mat-form-field>
    </div>

    <div class="action-buttons">
      <button
        color="primary"
        [disabled]="isScheduleButtonDisabled"
        class="action-btn"
        (click)="_schedule()"
      >
        {{ scheduleButtonText }}
      </button>

      @if (campaign?.status?.toLowerCase() === 'scheduled' || campaign?.status?.toLowerCase() === 'draft') {
        <button
          color="warn"
          class="cancel-btn"
          (click)="_cancelSchedule()"
        >
          Cancel
        </button>
      }
    </div>
  </div>
</div>
                </div>
              </div>
            </mat-tab>

            <!-- Recipient List Tab -->
            <mat-tab label="Recipient List">
              <div class="tab-content">
                <div class="recipient-container">
                  <div class="recipient-header">
                    <p class="recipient-count">
                      A total of <strong>{{ campaign.total_count }}</strong> recipients will be
                      included in this campaign.
                    </p>
                  </div>

                  <!-- Search -->
                  <div class="recipient-search">
                    <div class="table-toolbar">
                      <div id="recipient-filter-form" class="w-100">
                        <form class="row align-items-start">
                          <div class="col-sm-12 col-md-7 col-lg-5 col-xxl-5 m-0">
                            <div class="position-relative" style="max-width: 500px">
                              <input
                              #searchInput
                                type="text"
                                class="form-control border-0 shadow-sm pe-10 "
                                style="background: #f0f0f0; color: #1c3a7a"
                                placeholder="Search name, email, phone"
                                (keyup)="_onSearchRecipients($event)"
                              />

                              <!-- Search icon -->
                              <i
                                class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                                style="color: #888888"
                              ></i>

                              <!-- Clear button -->
                              <button *ngIf="searchInput.value"
                                type="button"
                                class="btn position-absolute top-50 end-0 translate-middle-y me-1 p-3 border-0 bg-transparent"
                                style="z-index: 100; cursor: pointer;"
                                (click)="searchInput.value = ''; _clearRecipientSearch()">
                              
                                <i class="fas fa-times" style="color: #888888; pointer-events: none;"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>

                  <!-- Recipients Table -->
                  <div class="table-wrapper">
                    <table mat-table [dataSource]="contactsDs" class="recipients-table">
                      <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                      </ng-container>

                      <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
                      </ng-container>

                      <ng-container matColumnDef="phone">
                        <th mat-header-cell *matHeaderCellDef>Phone</th>
                        <td mat-cell *matCellDef="let row">{{ row.phone }}</td>
                      </ng-container>

                      <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef>Status</th>
                        <td mat-cell *matCellDef="let row">
                          <span
                            class="status-chip"
                            [ngClass]="'status-' + row.status.toLowerCase()"
                          >
                            {{ row.status }}
                          </span>
                        </td>
                      </ng-container>

                      <tr
                        mat-header-row
                        *matHeaderRowDef="['name', 'email', 'phone', 'status']"
                      ></tr>
                      <tr
                        mat-row
                        *matRowDef="let row; columns: ['name', 'email', 'phone', 'status']"
                      ></tr>
                      <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">No recipients found.</td>
                      </tr>
                    </table>
                  </div>

                  <!-- Paginator -->
                  <mat-paginator
                    #paginator
                    [pageSizeOptions]="[5, 10, 25, 50]"
                    [pageSize]="5"
                    showFirstLastButtons
                    aria-label="Select page of recipients"
                  >
                  </mat-paginator>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</app-pias-layout>
